angular.module('pitch.app')
.controller('SelectOfficeModalCtrl',
    function($scope, OfficesLoader) {
        "use strict";

        $scope.officesLoader = new OfficesLoader({
            sortField: 'name',
            sortOrder: 'ASC',
        }).getAll();

        $scope.submit = function(office) {
            $scope.$close(true, office);
        };
    }
);



// WEBPACK FOOTER //
// ./src/AppBundle/Resources/js/angular/controllers/SelectOfficeModalCtrl.js